import React, { useEffect, useState, useRef } from 'react';
import { makeStyles } from "@material-ui/core/styles";
import { API_URL } from '../../../config';



const useStyles = makeStyles(() => ({
    customTooltip: {
        backgroundColor: "black",
        fontSize: "15px"
    }
}));

const EditDevice = ({ deviceid,editdeviceToggleModal,successeditdeviceToggleModal,godevicelist,devicekeyToggleModal }) => {

    const classes = useStyles();

    const [editdata, setEditdata] = useState([]);

    const [checkboxshow, setCheckboxshow] = useState(false)
    const [cmoduleval, setCmoduleval] = useState(0)
    const [mmoduleval, setMmoduleval] = useState(0)
    const [errorMessege, setErrorMessege] = useState(false);
    const [devicetype, setDevicetype] = useState(0)
    const [checkingboxmessge, setCheckingboxmessge] = useState(false);
    const [GoPersonaldefaultdata, setGoPersonaldefaultdata] = useState(5)



    useEffect(() => {
        getgodevicebyid()


    }, [])



    const HandleEditdeviceType = (e)=>{
        
        var val = e.target.value
        setDevicetype(e.target.value);

        setGoPersonaldefaultdata(6)
        
        if (val == "null") {
            setErrorMessege(true)
        } else {
            setErrorMessege(false)
        }

        setCmoduleval(0)
        setMmoduleval(0)

       

        if (val == 5) {
            setCheckboxshow(true)
            setCheckingboxmessge(true)
        } else {
            setCheckboxshow(false)
            setCheckingboxmessge(false)
           
        }
    }


    const HandleCmodule = (e) => {

        if (e.target.checked) {
            setCmoduleval(1)
        } else {
            setCmoduleval(0)
        }
    }

    const HandlemModule = (e) => {
        if (e.target.checked) {
            setMmoduleval(1)
        } else {
            setMmoduleval(0)
        }
    }


    const getgodevicebyid = () => {


        fetch(API_URL + "/get/go/device/by/" + deviceid,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',

                },
            }
        ).then((response) => {
            if (response.status == 200) {
                response.json().then((resp) => {
                    setEditdata(resp.data[0]) 
                    setDevicetype(resp.data[0].device_type)
                    setCmoduleval(resp.data[0].c_module)
                    setMmoduleval(resp.data[0].m_module)
                   
                    
                });
            }



        })
    }


    const editDevice = () => {


        let data = {};

        if (devicetype == "null") {
            setErrorMessege(true)
            return false;
        }

        // data['serial_key'] = validator.trim(editserialkey.current.value);
        data['device_type'] = devicetype;
        data['c_module'] = cmoduleval;
        data['m_module'] = mmoduleval;
    
        
        fetch(API_URL + "/update/device/" + deviceid, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',

            },
            body: JSON.stringify(data)
        }).then((response) => {

            if (response.status == 200) {
                response.json().then((resp) => {
                    editdeviceToggleModal()
                    successeditdeviceToggleModal()
                    godevicelist()
                });
            } else if (response.status == 400) {
                devicekeyToggleModal();
            }
            else {
                alert("network error")
            }

        })

    }




    return (
        <div>
            <ul className='deviceformlist'>
                <li>

                    {/* <div className="input-group mb-3 device-input">
                        <div className="input-group-prepend">
                            <span className="input-group-text" id="basic-addon1">GO-</span>
                        </div>
                        <input placeholder='Write serial key' defaultValue={editdata?.serial_key?.replace("GO-","")} ref={editserialkey} onChange={HandleEditSerialkey} />
                    </div> */}
                    <div className='select-device-type'>
                                    <select onChange={HandleEditdeviceType}>
                                        <option value="null">Select device type</option>
                                        <option selected={5 == editdata?.device_type? true : false} value="5">GO Personal</option>
                                        <option selected={6 == editdata?.device_type? true : false} value="6">GO Basic</option>
                                        <option selected={7 == editdata?.device_type? true : false} value="7">GO Professional</option>
                                    </select>

                                    {
                                         devicetype == 5 && <div className='wrp-checkbox-module'><input type="checkbox" onChange={HandleCmodule}  defaultChecked={1 == editdata?.c_module?true : false} /><label className='c_module'>C module</label> <input type="checkbox" defaultChecked={1 == editdata?.m_module?true : false} onChange={HandlemModule} className='mrl-module' /> <label>M module</label></div>
                                    }
 
                                    {
                                        ( devicetype == 5 && cmoduleval == 1 && mmoduleval == 1) &&<p>Please note that checking off C-module and M-module checkboxes together will make this a Go Basic device.</p>
                                    }

                                    
                                </div>
                    {
                        errorMessege && <p className='error-message'>Field required </p>
                    }

                </li>

                <li>
                    <div className='addBtn'>
                        <button onClick={editDevice}>Update</button>
                    </div>
                </li>

            </ul>
        </div>
    )
}

export default EditDevice;